(function () {
  document.documentElement.classList.add('hd-js');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveals = [...document.querySelectorAll('.hd-reveal')];
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('hd-inview');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: .08, rootMargin: '0px 0px -30px 0px' });
    reveals.forEach(el => revealObserver.observe(el));
  } else { reveals.forEach(el => el.classList.add('hd-inview')); }
  const video = document.querySelector('.hd-hero__film');
  if (!video) return;
  const toggle = document.querySelector('.hd-video-toggle');
  function tryPlay() { if (!reduceMotion && !video.dataset.userPaused) { const p = video.play(); if (p && p.catch) p.catch(() => {}); } }
  if (reduceMotion) { video.pause(); }
  else if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) tryPlay(); else video.pause(); });
    }, { threshold: .01 });
    videoObserver.observe(video);
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) video.pause(); else if (window.scrollY < window.innerHeight) tryPlay();
  });
  if (toggle) toggle.addEventListener('click', () => {
    if (video.dataset.userPaused) {
      delete video.dataset.userPaused;
      tryPlay();
      toggle.textContent = 'PAUSE FILM';
      toggle.setAttribute('aria-label', 'Pause background film');
      toggle.setAttribute('aria-pressed', 'false');
    } else {
      video.dataset.userPaused = 'true';
      video.pause();
      toggle.textContent = 'PLAY FILM';
      toggle.setAttribute('aria-label', 'Play background film');
      toggle.setAttribute('aria-pressed', 'true');
    }
  });
})();

// Built-in quick details: work immediately, without Shopify product setup.
(function(){
  let lastTrigger=null;
  document.addEventListener('click', function(ev){
    const opener=ev.target.closest('[data-hd-detail-open]');
    if(opener){
      const modal=document.getElementById(opener.getAttribute('data-hd-detail-open'));
      if(modal&&typeof modal.showModal==='function'){
        lastTrigger=opener;modal.showModal();
        document.documentElement.style.overflow='hidden';
      }
      return;
    }
    const closer=ev.target.closest('[data-hd-detail-close]');
    if(closer){const modal=closer.closest('dialog');if(modal)modal.close();return;}
    const thumb=ev.target.closest('[data-hd-image]');
    if(thumb){const dlg=thumb.closest('dialog'),main=dlg&&dlg.querySelector('[data-hd-detail-main]');
      if(main){main.src=thumb.getAttribute('data-hd-image');dlg.querySelectorAll('[data-hd-image]').forEach(t=>{const on=t===thumb;t.classList.toggle('is-active',on);t.setAttribute('aria-pressed',String(on));});}
      return;
    }
    const cta=ev.target.closest('[data-hd-detail-close-cta]');
    if(cta){const modal=cta.closest('dialog');if(modal)modal.close();}
  });
  document.querySelectorAll('dialog.hd-detail').forEach(modal=>{
    modal.addEventListener('click',ev=>{if(ev.target===modal)modal.close();});
    modal.addEventListener('close',()=>{document.documentElement.style.overflow='';if(lastTrigger&&document.contains(lastTrigger))lastTrigger.focus({preventScroll:true});});
  });
})();


// PDP variant price and availability follow the selected Shopify variant.
(function(){
  const selector=document.querySelector('[data-hd-variant-selector]');
  if(!selector)return;
  const price=document.querySelector('[data-hd-variant-price]');
  const button=document.querySelector('[data-hd-pdp-submit]');
  const sync=()=>{
    const option=selector.options[selector.selectedIndex];
    if(!option)return;
    if(price)price.textContent=option.dataset.price||price.textContent;
    if(button){const available=option.dataset.available==='true';button.disabled=!available;button.firstChild.textContent=available?'ADD TO BAG ':'SOLD OUT ';}
  };
  selector.addEventListener('change',sync);sync();
})();
